import { request } from '../../utils/request';

export const resetPassword = <T extends { [key: string]: string }>(
  formData: T,
  signal?: AbortSignal
) =>
  request({
    method: 'POST',
    url: '/auth/forgot-password',
    formData,
    callback: undefined,
    onError: (err) => {
      throw err;
    },
    signal,
  });

export const sendPasswordResetToken = (
  formData: {
    identifier: string;
    mode: 'email' | 'phone';
    via?: 'email' | 'sms' | 'whatsapp';
  },
  signal?: AbortSignal
) =>
  request({
    method: 'POST',
    url: '/auth/request/forgot-password',
    formData:
      formData.mode === 'phone'
        ? {
            phone: formData.identifier.trim(),
            via: formData.via || 'sms',
          }
        : {
            email: formData.identifier.toLowerCase().trim(),
            via: 'email',
          },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
    signal,
  });
